module.exports = __webpack_public_path__ + "img/xgk.a037bcfd.png";